export const WebCourses = [
    {
        image: require('../../assets/images/course/1.png'),
        category: "HTML",
        title: "Apprendre le HTML",
        description: "Structurez vos pages web grâce au HTML",
        level: "Beginner",
        levelDisplay: "Débutant",
        author: "Hanniel TSASSE",
        average: "3.9"
    },
    {
        image: require('../../assets/images/course/2.png'),
        category: "CSS",
        title: "Apprendre le CSS",
        description: "Ajoutez du style à vos contenu web grâce au CSS",
        level: "Beginner",
        levelDisplay: "Débutant",
        author: "Léo NGUIMDO",
        average: "4.8"
    },
    {
        image: require('../../assets/images/course/3.png'),
        category: "JS",
        title: "Apprendre le JavaScript",
        description: "Dynamisez vos site web avec JavaScript",
        level: "Beginner",
        levelDisplay: "Débutant",
        author: "Hanniel TSASSE",
        average: "4.1"
    },
    {
        image: require('../../assets/images/course/4.png'),
        category: "Angular",
        title: "Apprendre Angular",
        description: "Allez à la découverte du framework Angular",
        level: "Intermediate",
        levelDisplay: "Intermédiaire",
        author: "Fredy PONE",
        average: "3.7"
    },
    {
        image: require('../../assets/images/course/5.png'),
        category: "React.js",
        title: "Apprendre le React.js",
        description: "Apprenez à faire des front-end réactif plus simplement avec React.js",
        level: "Intermediate",
        levelDisplay: "Intermédiaire",
        author: "Hanniel TSASSE",
        average: "4.4"
    },
    {
        image: require('../../assets/images/course/6.png'),
        category: "Node.js",
        title: "Apprendre le Node.js",
        description: "Apprenez à faire des back-end à partir du JavaScript",
        level: "Advanced",
        levelDisplay: "Avancé",
        author: "Hanniel TSASSE",
        average: "4.4"
    }
]